import { Search, ArrowRight } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function TrackingBar() {
  const [tid, setTid] = useState("");
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (!tid.trim()) return;
    navigate(`/track/${tid.trim().toUpperCase()}`);
  };
  return (
    <section className="bg-[#0A0A0A] text-white py-16 md:py-24 relative overflow-hidden grain">
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }} className="md:col-span-5">
          <p className="font-mono-label text-xs text-[#FF4500]">LIVE LOAD TRACKING</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl mt-4 leading-[1]">
            Where&apos;s<br/>my <span className="italic">load?</span>
          </h2>
        </motion.div>
        <motion.form
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          onSubmit={submit} className="md:col-span-7 flex flex-col sm:flex-row gap-3" data-testid="tracking-form">
          <input
            value={tid}
            onChange={(e) => setTid(e.target.value)}
            placeholder="Enter load ID (e.g. ATDEMO001)"
            className="flex-1 bg-white text-black px-5 py-4 border border-white/20 focus:outline-none focus:border-[#FF4500] font-mono-label text-sm tracking-wider"
            data-testid="tracking-input"
          />
          <button type="submit" className="sharp-btn bg-[#FF4500] text-white px-6 py-4 font-medium text-sm hover:bg-white hover:text-black inline-flex items-center justify-center gap-2" data-testid="tracking-submit">
            <Search size={16}/> Track <ArrowRight size={16}/>
          </button>
        </motion.form>
        <p className="md:col-span-12 text-xs text-white/50 font-mono-label mt-2">
          Try <button type="button" onClick={() => setTid('ATDEMO001')} className="underline hover:text-[#FF4500]" data-testid="tracking-demo-link">ATDEMO001</button> or <button type="button" onClick={() => setTid('ATDEMO002')} className="underline hover:text-[#FF4500]" data-testid="tracking-demo-link-2">ATDEMO002</button>
        </p>
      </div>
    </section>
  );
}
